module.exports = __webpack_public_path__ + "img/company-light.41be471b.png";